"use client";

import { motion } from "framer-motion";
import { useLang } from "@/contexts/language-context";
import { Check, Globe } from "lucide-react";

export default function MicrositeDomainScroll() {
  const { t } = useLang();

  return (
    <section className="relative py-32 px-6 bg-[#0F0B1F] text-white overflow-hidden">
      <div className="max-w-[1200px] mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16 max-w-[760px] mx-auto"
        >
          <div className="text-[11px] font-black tracking-widest uppercase mb-4" style={{ color: "#F472B6" }}>
            {t("Domain options", "Opciones de dominio")}
          </div>
          <h2 className="text-4xl md:text-[64px] font-black tracking-[-0.03em] leading-[1.02]">
            {t("Redy link included. ", "Link de Redy incluido. ")}
            <span className="text-white/30">{t("Custom on PRO.", "Custom en PRO.")}</span>
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: [0.21, 0.47, 0.32, 0.98] }}
          className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-[860px] mx-auto"
        >
          {/* Free Nightlife tier */}
          <div className="bg-white/[0.04] backdrop-blur-xl border border-white/10 rounded-[24px] p-7">
            <div className="text-[10px] font-black tracking-widest uppercase text-white/45 mb-4">
              {t("Redy Nightlife $147", "Redy Nightlife $147")}
            </div>

            <div className="bg-white/[0.03] border border-white/10 rounded-[14px] px-4 py-3 mb-5 flex items-center gap-2.5">
              <Globe className="w-4 h-4 text-white/55" />
              <div
                className="font-bold text-[15px] tracking-tight text-white"
                style={{ fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace" }}
              >
                <span>useredy.com/venue/</span>
                <span className="text-white/55">neonclub</span>
              </div>
            </div>

            <div className="space-y-2">
              {[
                t("SSL included", "SSL incluido"),
                t("Custom branding (logo + colors)", "Branding custom (logo + colores)"),
                t("Event list auto-synced", "Lista de eventos auto-sync"),
                t("Public, shareable page", "Página pública para compartir"),
              ].map((feat) => (
                <div key={feat} className="flex items-center gap-2 text-[13px]">
                  <Check className="w-3.5 h-3.5" style={{ color: "#2ECC71" }} strokeWidth={3} />
                  <span className="text-white/75">{feat}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Pro tier */}
          <div
            className="rounded-[24px] p-7 shadow-2xl text-white relative overflow-hidden"
            style={{
              background: "linear-gradient(135deg, #1A1A1A 0%, #2A1A1A 100%)",
            }}
          >
            <div
              className="absolute top-0 right-0 w-[300px] h-[300px] rounded-full pointer-events-none"
              style={{ background: "radial-gradient(circle, rgba(244,114,182,0.20) 0%, transparent 65%)" }}
            />
            <div className="relative">
              <div className="text-[10px] font-black tracking-widest uppercase mb-4" style={{ color: "#F472B6" }}>
                {t("Nightlife PRO $197", "Nightlife PRO $197")}
              </div>

              <div className="bg-white/10 backdrop-blur border border-white/15 rounded-[14px] px-4 py-3 mb-5 flex items-center gap-2.5">
                <Globe className="w-4 h-4" style={{ color: "#F472B6" }} />
                <div
                  className="font-bold text-[15px] tracking-tight text-white"
                  style={{ fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace" }}
                >
                  neonclub.com
                </div>
              </div>

              <div className="space-y-2">
                {[
                  t("Everything in Nightlife", "Todo lo de Nightlife"),
                  t("Custom domain (yourname.com)", "Dominio custom (tudominio.com)"),
                  t("Step-by-step DNS records", "Registros DNS paso a paso"),
                  t("Promoter links & bar tabs included", "Links de promotores y tabs de barra"),
                ].map((feat) => (
                  <div key={feat} className="flex items-center gap-2 text-[13px]">
                    <Check className="w-3.5 h-3.5" style={{ color: "#F472B6" }} strokeWidth={3} />
                    <span className="text-white/85">{feat}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
